import { Component, Input } from '@angular/core';

@Component({
  selector: 's-polaris-select',
  templateUrl: './s-polaris-select.component.html',
  styleUrls: ['./s-polaris-select.component.scss'],
  standalone: false,
})
export class PolarisSelectComponent {
  @Input() label = '';
  @Input() value?: string;
}
